{
  "stick": {
    "LINE_W": 0.24,
    "HEAD_R": 0.5,
    "HEAD_Y": -0.6,
    "HIP_Y": 0.7,
    "HIP_DX": 0.12,
    "THIGH_LEN": 0.88,
    "SHIN_LEN": 0.88,
    "KNEE_R": 0.11,
    "SHOULDER_Y": 0.2,
    "UPPER_ARM_LEN": 0.58,
    "FOREARM_LEN": 0.54,
    "ELBOW_R": 0.09,
    "ARM_REACH": 0.88,
    "RIDE": 0.9
  }
}
